// extracted by mini-css-extract-plugin
module.exports = {"attendantInfo":"styles_attendantInfo__2uwSK","chatInfo":"styles_chatInfo__3H8HX","infoItem":"styles_infoItem__3MabT","itemIcon":"styles_itemIcon__3VyoB"};